import React, { useState, useEffect } from 'react';
import Loader from '../../../components/Loader/Loader';
import { postCorrectiveActionPlanUpdate } from '../../../apiservices/ApiServices';
import DateFild from '../../../components/DateTimePicker/DateFild';

const RecommendationActionPlan = ({ details, toast }) => {
    const [isLoadings, setLoadings] = useState(false);
    const [correctiveActions, setCorrectiveActions] = useState([
        {
            id: '',
            department: '',
            action: '',
            deadline: '',
            responsible: '',
            escalation: '',
            closureCriteria: '',
        }
    ]);

    useEffect(() => {
        if (details?.corrective_action_plan && Array.isArray(details?.corrective_action_plan)) {
            const updatedActionPlan = details?.corrective_action_plan.map(item => {
                return {
                    id: item.id,
                    department: item.department,
                    action: item.action,
                    deadline: item.deadline,
                    responsible: item.responsible,
                    escalation: item.escalation,
                    closureCriteria: item.closureCriteria,
                };
            });
            setCorrectiveActions(updatedActionPlan);
        }
    }, [details]);

    const handleCorrectiveActionChange = (index, field, value) => {
        const updatedActions = [...correctiveActions];
        updatedActions[index] = { ...updatedActions[index], [field]: value };
        setCorrectiveActions(updatedActions);
    };

    const submitData = async () => {
        const formattedCorrectiveActions = correctiveActions.map(action => ({
            Department: action.department,
            Action: action.action,
            Deadline: action.deadline,
            Responsible: action.responsible,
            Escalation: action.escalation,
            ClosureCriteria: action.closureCriteria
        }));

        const postdata = {
            incident_header_id: details?.header_id,
            corrective_action_plan: formattedCorrectiveActions,
        };
        //console.log('postdata', postdata)
        setLoadings(true);
        try {
            const res = await postCorrectiveActionPlanUpdate(postdata);
            toast.success(res.data.message);
        } catch (error) {
            toast.error(error?.response?.data?.message || 'Something went wrong');
        } finally {
            setLoadings(false);
        }
    };

    const formatDate = (dateString) => {
        const [year, month, day] = dateString.split('-');
        return `${day}/${month}/${year}`;
    };


    return (
        <>
            <div className="form-box">
                <div className="fieldset intl Recommendation_action_plan">
                    <h1>Initial Recommendation Action Plan</h1>
                    <div className="formsBox">
                        <div className="table-responsive">
                            <table className="table">
                                <thead>
                                    <tr>
                                        <th>Department</th>
                                        <th>Action</th>
                                        <th>Deadline</th>
                                        <th>Responsible</th>
                                        <th>Escalation</th>
                                        <th>Closure Criteria</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {correctiveActions.map((action, index) => (
                                        <tr key={index}>
                                            <td>{action.department}</td>
                                            <td>{action.action}</td>
                                            <td>{formatDate(action.deadline)}</td>
                                            <td>{action.responsible}</td>
                                            <td>{action.escalation}</td>
                                            <td>{action.closureCriteria}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                    {/* <div className="button-boxs grid pb-2">
                        <button type="submit" onClick={submitData} className="btn btn-orange">Submit</button>
                    </div> */}
                </div>
            </div>
            {isLoadings && <Loader />}
        </>
    );
};

export default RecommendationActionPlan;
